<script setup>

import { onMounted, ref } from 'vue'
import taskService from '@/services/task.service'
import rentingService from '@/services/renting.service'
import propertyService from '@/services/property.service'
import locationService from '@/services/location.service'
import enumService from '@/services/enum.service'
import ProgressSpinner from 'primevue/progressspinner'
import Icon from '@/components/Icon/Icon.vue'
import Location from '@/components/embed/Location.vue'
import moment from 'moment'
import 'moment/dist/locale/fr'

const loading = ref(false)
const renting = ref({})
const property = ref({})
const location = ref({})
const taskStatus = ref([])

const props = defineProps({
    data: {
        active: Object,
        required: true,
    }
})

const emit = defineEmits(['changeTask'])

const getPassage = (passage) => {
    if(passage == 1) {
        return 'Sortie'
    }

    return 'Entrée'
}

const validInventory = (data) => {
    taskService.modify(data.uuid, {
        status: 1
    })
    .then(() => {
        props.data.status = 1

        emit('changeTask', data.uuid)
    })
}

const cancelInventory = (data) => {
    taskService.modify(data.uuid, {
        status: 2
    })
    .then(() => {
        props.data.status = 2

        emit('changeTask', data.uuid)
    })
}

onMounted(() => {
    enumService.get('task-status')
    .then(response => {
        taskStatus.value = response.data.task_status
    })

    rentingService.getInstance(props.data.tsi.renting_uuid)
    .then((response) => {
        renting.value = response.data

        propertyService.getInstance(renting.value.property_uuid)
        .then((responseProperty) => {
            property.value = responseProperty.data

            locationService.getOne(property.value.location_uuid)
            .then((responseLocation) => {
                location.value = responseLocation.data

                loading.value = true
            })
        })
    })
})

</script>

<template>

<div class="px-20 py-4">
    <div v-if="loading">
        <div v-if="data.status == 0" class="mt-2 line flex flex-row justify-between">
            <div>
                <Location :location="location" />
            </div>
            <div>
                <span>Rendez-vous : {{ moment(data.tsi.appointment_datetime).format('DD/MM/YYYY à HH:mm') }}</span>
                <br />
                <span>Passage : {{ getPassage(data.tsi.passage) }}</span>
            </div>
            <div class="flex gap-1 my-auto h-8">
                <button class="rounded border border-black cursor-pointer my-auto px-1.5 py-1 shadow-md hover:shadow-none hover:bg-green-500" @click="validInventory(data)" title="Etat des lieux effectué">
                    <Icon name="valid" :size="12" color="black" class="w-4 h-4" />
                </button>
                <button class="rounded border border-black cursor-pointer my-auto px-1.5 py-1 shadow-md hover:shadow-none hover:bg-red-500" @click="cancelInventory(data)" title="Etat des lieux annulé">
                    <Icon name="cancel" :size="12" color="black" class="w-4 h-4" />
                </button>
            </div>
        </div>
        <div v-else="" class="mt-2 line flex flex-row justify-between">
            <span>État des lieux terminé</span>
        </div>
    </div>
    <div v-else class="mx-4 w-full flex justify-center">
        <ProgressSpinner
            style="width: 50px; height: 50px"
            strokeWidth="5"
            fill="transparent"
            animationDuration="2.5s"
            aria-label="Custom ProgressSpinner"
            class="m-auto"
        />
    </div>
</div>

</template>
